import { Switch } from 'antd';
import * as React from 'react';
import { ISwitchProps } from './entities';

const BCSwitch = (props: ISwitchProps) => {
	const [checked, setChecked] = React.useState(props.checked);

	React.useEffect(() => {
		setChecked(props.checked);
	}, [props.checked]);

	const onChange = (checked: boolean, event?: React.MouseEvent<HTMLButtonElement>) => {
		if (!props.readOnly) {
			setChecked(checked);
			if (props.onChange) {
				props.onChange(checked, event);
			}
		} else {
			setChecked(!checked);
		}
	};

	return (
		<Switch
			autoFocus={props.autoFocus}
			onChange={onChange}
			disabled={props.disabled}
			size={props.size}
			checked={checked}
			checkedChildren={props.checkedChildren}
			unCheckedChildren={props.unCheckedChildren}
			style={props.style}
			className={props.className}
			data-selenium-id={props.seleniumId}
		/>
	);
};

export default BCSwitch;

export { ISwitchProps };
